import React from 'react';

interface SectionTitleProps {
  title: React.ReactNode;
}

export const SectionTitle = ({ title }: SectionTitleProps) => {
  return (
    <h3 className="m-0 mb-32 border-0 border-b border-solid border-primary-black pb-12 font-suisse-intl-mono text-overline-lg text-primary-black">
      {title}
    </h3>
  );
};
